// extracted by mini-css-extract-plugin
module.exports = {"form":"forms_form__pnzPY","submitButton":"forms_submitButton__X9bCJ","infoWrapper":"forms_infoWrapper__9ZpC2","info":"forms_info__KxRTA"};